import React, { useMemo } from 'react';

import { Box, Chip, Typography } from '@mui/material';

import { ConfidenceScoreTier, SurchargeSuggestionBQ } from '../types';

function calculateTopUpSymbol(topUpSinceLastSurcharge = 0) {
  let topUpSymbol = '';
  if (topUpSinceLastSurcharge > 0) {
    topUpSymbol = '🔼';
  } else if (topUpSinceLastSurcharge < 0) {
    topUpSymbol = '🔽';
  }
  return topUpSymbol;
}

export default function SecondColumnStatisticsFormatter({ row }: { row: SurchargeSuggestionBQ }) {
  const topUpSymbol = calculateTopUpSymbol(row.top_up_since_last_surcharge);

  const confidenceColour = useMemo(() => {
    switch (row.confidence) {
      case ConfidenceScoreTier.HIGH:
        return 'success';
      case ConfidenceScoreTier.MEDIUM:
        return 'warning';
      case ConfidenceScoreTier.LOW:
        return 'error';
      default:
        return 'default';
    }
  }, [row.confidence]);

  return (
    <Box>
      {row.confidence && (
        <Typography variant="body1">
          <Typography component="span" fontWeight="bold">
            Confidence:
          </Typography>{' '}
          <Chip component="span" label={row.confidence.toUpperCase()} size="small" color={confidenceColour} />
        </Typography>
      )}
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Booked / Allocated:
        </Typography>{' '}
        {row.booked + '/' + row.allocated}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Booked / Allocated (+-2 days):
        </Typography>{' '}
        {`${row.booked_sum_minus_two_days + row.booked_sum_plus_two_days}/${
          row.allocated_sum_minus_two_days + row.allocated_sum_plus_two_days
        }`}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Sales last 3 days:
        </Typography>{' '}
        {row.sales_last_3_days}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Sold since last surcharge:
        </Typography>{' '}
        {row.sold_since_last_surcharge ?? 0}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Top up since last surcharge:
        </Typography>{' '}
        {`${topUpSymbol} ${Math.abs(row.top_up_since_last_surcharge ?? 0)}`}
      </Typography>
      <Typography variant="body1">
        <Typography component="span" fontWeight="bold">
          Number of days left online:
        </Typography>{' '}
        {row.days_remaining}
      </Typography>
    </Box>
  );
}
